import react, {useEffect, useState} from 'react';
import Loader from "../../../../Loader/Loader";
import React from "react";
import DashboardMenu from "../../../layout/dashboardMenu";
import Header from "../../../layout/header";
import NotFoundData from "../../../../Images/no-data-found.webp";
import {toast} from "react-toastify";
import BottomMenu from "../../../layout/bottomMenu";

const PjpPendingList = ({
                           history,
                           getAM,
                           allAm= [],
                           pjpPending,
                           PJPPendingList = [],
                            pjpPendingApprove,
                            PJPApprovalDetails = [],
                            match
                       }) => {

    const [isLoading, setIsLoading] = useState(false)
    const [remark, setRemark] = useState('')
    const [userId, setUserId] = useState([])
    const [roleId, setRoleId] = useState([])
    const [open, setOpen] = useState(false);
    const [filterInputList, setFilterInputList] = useState([{}])
    const [isFilterRemove, setIsRemoveFilter] = useState(false)

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            await getAM(2);
            setRoleId(window.localStorage.role_id)
            setUserId(window.localStorage.user_id)
            if(match?.params?.request_id){
                let filter = window.localStorage.pjp_pending ? JSON.parse(window.localStorage.pjp_pending) : [{}];
                setFilterInputList(filter)
                await pjpPending(match?.params?.request_id, 1, filter)
            }
            setIsLoading(false)
        })();
    }, []);

    const handleFetchTollDetails = async (userId) => {
        setIsLoading(true)
        setUserId(userId)
        await pjpPending(match?.params?.request_id, 1, filterInputList)
        setIsLoading(false)
    }

    const handleSubmit = async (e, status) => {
        e.preventDefault();
        if(status === 3 && !remark){
            toast.warning("Remark is required!")
            return false;
        }

        const list = {};
        list['remark'] = remark;
        list['user_id'] = match?.params?.user_id;
        list['status'] = status;
        setIsLoading(true)
        await pjpPendingApprove(list)
        setIsLoading(false)
    }

    const handleSubmitFilter = async () => {
        setOpen(false)
        setIsLoading(true)
        window.localStorage.pjp_pending = JSON.stringify(filterInputList)
        await pjpPending(match?.params?.request_id, 1, filterInputList)
        setIsLoading(false)
    }

    const handleFilter = async (key, value, stringValue = '') => {
        const list = [...filterInputList]
        list[0][key] = value
        setFilterInputList(list)
    }

    const handleRemoveFilter = async (key) => {
        if (key !== '') {
            delete filterInputList[0][key]
            setFilterInputList(filterInputList)
            setIsLoading(true)
            if(filterInputList[0].length === 0){
                delete window.localStorage.pjp_pending
            } else {
                window.localStorage.pjp_pending = JSON.stringify(filterInputList)
            }
            await pjpPending(match?.params?.request_id, 1, filterInputList)

            setIsLoading(false)
        }
    }


    useEffect(() => {
        if (PJPApprovalDetails?.status === 200) {
            toast.success(PJPApprovalDetails?.message)
            setTimeout(() => {
                window.location.href="/pjp-review"
            }, 1000)
        } else if (PJPApprovalDetails?.status && PJPApprovalDetails?.status !== 200) {
            toast.error(PJPApprovalDetails?.message)
        }
    }, [PJPApprovalDetails])

    return (
        <>
            <Loader isLoading={isLoading}/>
            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={'PJP Approval Pending'}
                            history={history}
                        />
                        <div className="container-fluid common-bg">
                            <div className="d-sm-flex align-items-center justify-content-between mb-4">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="col-sm-12 col-md-12 col-lg-12 d-flex">
                                            <h4 className="col-md-6 mt-4 header-title">
                                                PJP Pending Request
                                            </h4>
                                            <div className="col-md-6 cs-pos mb-14">
                                                <button onClick={() => setOpen(!open)}
                                                        className="btn btn-sm btn-primary mr-1 mt-3 mr-4 btn-filter"
                                                        type="button"><i
                                                    className="fa fa-filter lh-35 pd-3"></i>
                                                </button>
                                            </div>
                                        </div>
                                        {filterInputList[0] !== undefined && Object.keys(filterInputList[0]).length > 0 &&
                                            <div className="d-sm-flex align-items-center justify-content-between mb-4">
                                                <div className="row pd-filter-div">
                                                    <div className="col-md-12 col-sm-12 mt-6 d-flex">
                                                        <div className="applied-filter">
                                                            {Object.keys(filterInputList[0]).map((val, i) => {
                                                                return (
                                                                    <>
                                                            <span className="fd-1">
                                                                <span style={{textTransform: "capitalize"}}>
                                                                    {val.replaceAll("_", " ")}
                                                                </span>
                                                                {" - " + filterInputList[0][val]}
                                                                <i className="bi bi-x-circle" onClick={(e) => {
                                                                    handleRemoveFilter(val)
                                                                }}></i></span>
                                                                    </>
                                                                )
                                                            })}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        {parseInt(roleId) !== 29 && !match?.params?.user_id &&
                                            <div className="default-tab col-md-11">
                                                {allAm?.data &&
                                                    <select onChange={(e) => {handleFetchTollDetails(e.target.value)}} className="mb-5 col-md-12 col-sm-12 mt-3" style={{borderRadius:"10px"}}>
                                                        <option>Select AM</option>
                                                        {allAm?.data.map((val, i) => {
                                                            return (
                                                                <>
                                                                    {parseInt(match?.params?.user_id) === val?.id ?
                                                                        <option value={val?.id} selected>{val?.name+"("+val?.email+")"}</option>
                                                                        : <option value={val?.id}>{val?.name+"("+val?.email+")"}</option>
                                                                    }
                                                                </>
                                                            )
                                                        })}
                                                    </select>
                                                }
                                            </div>
                                        }

                                        {(parseInt(roleId) !== 67) && PJPPendingList?.data && PJPPendingList?.data.length > 0 &&
                                            <>
                                                <div className="row mt-10">
                                                    {PJPPendingList?.data.map((value, ii) => {
                                                    return (
                                                        <>
                                                            { ii !== PJPPendingList?.data.length-1  &&
                                                                <div className="col-md-4 col-sm-6">
                                                                    <div className="card-big-shadow card-padding" style={{marginLeft:"-11px"}}>
                                                                        <div className="card card-just-text"
                                                                             data-background="color"
                                                                             data-color=""
                                                                             data-radius="none">
                                                                            <div className="content">
                                                                                <h6 className="category">
                                                                                    <div className="header-ui-item-opp bg-green">
                                                                                        {value?.client_name}
                                                                                    </div>

                                                                                    <div className="row">
                                                                                    {/*    <div className="col-10" style={{*/}
                                                                                    {/*        color: "#000",*/}
                                                                                    {/*        fontSize: "20px",*/}
                                                                                    {/*        textAlign: "left",*/}
                                                                                    {/*        paddingLeft: "20px"*/}
                                                                                    {/*    }}>*/}
                                                                                    {/*<span*/}
                                                                                    {/*    className="">{value?.fast_tag_toll_no}*/}
                                                                                    {/*</span>*/}
                                                                                    {/*    </div>*/}
                                                                                        {parseInt(value?.status) === 2 &&
                                                                                            <div className="col-2">
                                                                                                {/*TOGGLE*/}
                                                                                                <div className="dropdown"
                                                                                                     style={{"float": "right"}}>
                                                                                                    <i className="bi bi-three-dots-vertical"
                                                                                                       data-toggle="dropdown"
                                                                                                       style={{color: "black"}}></i>
                                                                                                    <ul className="dropdown-menu" style={{left:"-4rem !important"}}>
                                                                                                        <li className="bg-amber-hover"><a
                                                                                                            href="#"
                                                                                                            className="btn btn-sm"
                                                                                                            type="button"
                                                                                                        >View FSE Details</a>
                                                                                                        </li>
                                                                                                        {parseInt(value?.assigned_to) === parseInt(userId)  &&
                                                                                                            <>
                                                                                                                {value?.am_visited_info ?
                                                                                                                    <li className="bg-amber-hover"><a
                                                                                                                        href={`fse-details/${value?.account_id}`}
                                                                                                                        className="btn btn-sm"
                                                                                                                        type="button"
                                                                                                                    >View Visit Details</a>
                                                                                                                    </li>
                                                                                                                    :
                                                                                                                    <li className="bg-amber-hover"><a
                                                                                                                        href={`pjp-visit/${value?.account_id}/${value?.id}/${match?.params?.request_id}`}
                                                                                                                        className="btn btn-sm"
                                                                                                                        type="button"
                                                                                                                    >Complete</a>
                                                                                                                    </li>
                                                                                                                }
                                                                                                            </>
                                                                                                        }

                                                                                                    </ul>
                                                                                                </div>
                                                                                                {/*TOGGLE END*/}
                                                                                            </div>
                                                                                        }
                                                                                    </div>
                                                                                    <div className="row list-view">
                                                                                        <div className="mb-flex">
                                                                                            <div
                                                                                                className="col-md-6 col-sm-6 no-wrap">
                                                                                                <i className="fas fa-comment"></i>&nbsp;&nbsp;Plaza Id
                                                                                            </div>
                                                                                            <div className="col-md-6 col-sm-6">
                                                                                        <span className="trigger"
                                                                                              data-tooltip-id="1"
                                                                                              title={value?.fast_tag_toll_no}>
                                                                                            {value?.fast_tag_toll_no}
                                                                                        </span>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="mb-flex">
                                                                                            <div
                                                                                                className="col-md-6 col-sm-6 no-wrap">
                                                                                                <i className="fas fa-check-circle"></i>&nbsp;&nbsp;City
                                                                                            </div>
                                                                                            <div className="col-md-6 col-sm-6">
                                                                                        <span className="trigger"
                                                                                              data-tooltip-id="1"
                                                                                              title={value?.city_name}>
                                                                                            {value?.city_name}
                                                                                        </span>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="mb-flex">
                                                                                            <div
                                                                                                className="col-md-6 col-sm-6 no-wrap">
                                                                                                <i className="bi bi-building"></i>&nbsp;&nbsp;State
                                                                                            </div>
                                                                                            <div className="col-md-6 col-sm-6">
                                                                                        <span className="trigger"
                                                                                              data-tooltip-id="1"
                                                                                              title={value?.state_name}>
                                                                                            {value?.state_name}
                                                                                        </span>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="mb-flex">
                                                                                            <div
                                                                                                className="col-md-6 col-sm-6 no-wrap">
                                                                                                <i className="fas fa-check-circle"></i>&nbsp;&nbsp;Date
                                                                                            </div>
                                                                                            <div className="col-md-6 col-sm-6">
                                                                                        <span className="trigger"
                                                                                              data-tooltip-id="1"
                                                                                              title={value?.schedule_date}>
                                                                                            {value?.schedule_date}
                                                                                        </span>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>

                                                                                    <hr/>
                                                                                </h6>
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            }
                                                        </>
                                                    )
                                                })}
                                                </div>
                                            </>
                                        }
                                        {parseInt(roleId) === 67 && PJPPendingList?.data && PJPPendingList?.data.length > 0 && PJPPendingList?.data.map((value, ii) => {
                                            return (
                                                <>
                                                    { ii !== PJPPendingList?.data.length-1  &&
                                                        <div className="col-md-12 col-sm-12 d-flex">
                                                        <div className="col-md-2 float-field ">
                                                            <input type="text"
                                                                   className="form-control form-control-user"
                                                                   placeholder=" "

                                                                   value={value?.fast_tag_toll_no}
                                                                   disabled={true}
                                                                   required
                                                            />
                                                            <label className="large-label float-lb">
                                                                Plaza Id
                                                            </label>
                                                        </div>
                                                        <div className="col-md-2 float-field ">
                                                            <input type="text"
                                                                   className="form-control form-control-user"
                                                                   placeholder=" "
                                                                   disabled={true}
                                                                   value={value?.client_name}
                                                                   required
                                                            />
                                                            <label className="large-label float-lb">
                                                                Plaza Name
                                                            </label>
                                                        </div>
                                                        <div className="col-md-2 float-field ">
                                                            <input type="text"
                                                                   className="form-control form-control-user"
                                                                   placeholder=" "
                                                                   disabled={true}
                                                                   value={value?.city_name?? " "}
                                                                   required
                                                            />
                                                            <label className="large-label float-lb">
                                                                City
                                                            </label>
                                                        </div>
                                                        <div className="col-md-2 float-field ">
                                                            <input type="text"
                                                                   className="form-control form-control-user"
                                                                   placeholder=" "
                                                                   disabled={true}
                                                                   value={value?.state_name ?? " "}
                                                                   required
                                                            />
                                                            <label className="large-label float-lb">
                                                                State
                                                            </label>
                                                        </div>
                                                        <div className="col-md-2 float-field ">
                                                            <input type="text"
                                                                   className="form-control form-control-user"
                                                                   placeholder=" "
                                                                   value={value?.schedule_date}
                                                                   disabled={true}
                                                            />
                                                            <label className="large-label float-lb">
                                                                Date
                                                            </label>
                                                        </div>
                                                    </div>
                                                    }
                                                </>
                                            )
                                        })}
                                        {PJPPendingList?.data && PJPPendingList?.data.length === 0 &&
                                            <div className="text-center">
                                                <img src={NotFoundData} className="not-found-data" alt={"not found"} />
                                                <br/>
                                                <div style={{fontSize:"large", fontWeight:"400"}}>
                                                    No Pending request found
                                                </div>
                                            </div>
                                        }

                                        {parseInt(roleId) === 67 && PJPPendingList?.data && PJPPendingList?.data.length > 0 &&
                                            <>
                                                <div className="userWords" style={{color:"cornflowerblue", left:"6px"}}>
                                                    Remark
                                                </div>
                                                <textarea
                                                    className="form-control form-control-user"
                                                    placeholder="Remark"
                                                    onChange={(e) => {
                                                        setRemark(e.target.value)
                                                    }}
                                                    required={true}
                                                    rows="4" cols="50"
                                                />
                                            </>
                                        }


                                        {parseInt(roleId) === 67 && PJPPendingList?.data && PJPPendingList?.data.length > 0 &&
                                            <div className="d-flex">
                                                <button
                                                    className="btn btn-sm btn-primary ml-3"
                                                    onClick={(e) => {handleSubmit(e, 2)}}
                                                >
                                                    Approve
                                                </button>
                                                <button
                                                    className="btn btn-sm btn-primary ml-3"
                                                    onClick={(e) => {handleSubmit(e, 3)}}
                                                >
                                                    Reject
                                                </button>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <BottomMenu
                    open={open}
                    setOpen={setOpen}
                    handleSubmitFilter={handleSubmitFilter}
                    filterContent={{data: [{'field': 'date', 'place_holder': 'from_date', 'values': ''}, {'field': 'date', 'place_holder': 'to_date', 'values': ''}]}}
                    handleFilter={handleFilter}
                    setIsRemoveFilter={setIsRemoveFilter}
                />
            </div>
        </>
    )
}

export default PjpPendingList